import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'zignal-landscape/lib/Modal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import ModalBody from 'zignal-landscape/lib/ModalBody';
import ModalFooter from 'zignal-landscape/lib/ModalFooter';
import Button from 'zignal-landscape/lib/Button';
import ButtonGroup from 'zignal-landscape/lib/ButtonGroup';

const DeleteConfirmationModal = ({
  isOpen = false,
  onClose,
  onConfirm,
  location = null,
  isDeleting = false,
  deleteError = null,
}) => (
  <Modal
    isOpen={isOpen}
    size="small"
    onEscapePress={onClose}
    onBackdropClick={onClose}
  >
    <ModalHeader hideCloseButton={false} onClose={onClose}>
      Delete Default Location
    </ModalHeader>

    <ModalBody>
      <div>
        {location && (
          <p>
            Are you sure you want to delete the default location for term{' '}
            <strong>&apos;{location.term}&apos;</strong> on platform{' '}
            <strong>&apos;{location.platform}&apos;</strong>?
          </p>
        )}
        {deleteError && (
          <p style={{color: '#d9534f', marginTop: '8px'}}>{deleteError}</p>
        )}
      </div>
    </ModalBody>

    <ModalFooter>
      <ButtonGroup align="right">
        <Button buttonStyle="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          buttonStyle="negative"
          disabled={isDeleting}
          onClick={onConfirm}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </ButtonGroup>
    </ModalFooter>
  </Modal>
);

DeleteConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  location: PropTypes.shape({
    term: PropTypes.string,
    platform: PropTypes.string,
  }),
  isDeleting: PropTypes.bool,
  deleteError: PropTypes.string,
};

export default DeleteConfirmationModal;
